/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_DeliveredInputs */

const vi_dashboard_driver_delivered = /** @type {(inputs: Dashboard_Driver_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao`)
};

/**

* @param {Dashboard_Driver_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_delivered = /** @type {((inputs?: Dashboard_Driver_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_delivered(inputs)
});